<template>
  <v-carousel
    @change="updateSlide"
    v-model="workShopSlideComputed"
    :style="carouselStyle"
    :dark="$vuetify.theme.dark"
    :light="!$vuetify.theme.dark"
    :hide-delimiters="true"
    height="100%"
  >
    <HelpText
      v-if="!$vuetify.breakpoint.mobile"
      :slide-title="slideTitle"
      :help-text="helpText"
      :reminder-text="reminderText"
      :about-text="aboutText"
      :show-help-text="showHelpText"
      :show-about-text="showAboutText"
      :toggle-help-text="toggleHelpText"
      :toggle-about-text="toggleAboutText"
      :show-reminder-modal="showReminderModal"
      :toggle-reminder-modal="toggleReminderModal"
      :update-slide="updateSlide"
    />

    <v-dialog
      :value="showReminderModal"
      width="50%"
      @click:outside="showReminderModal = false"
    >
      <v-card
        style="min-height: 50vh; max-height: 70vh; overflow-y: auto;"
        class="text-center"
      >
        <v-toolbar dark color="primary" style="margin-bottom: 10%;">
          <v-toolbar-title>
            Reminder
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text style="padding-top: 2%">
          <p class="text-center help">
            Did you review the executive summary prepared by the proposer interested in the SR 316 Express Lanes project?
          </p>
          <p class="text-center help">
            <strong>Remember to submit comments for the executive summary by July 3, 2021. </strong>
          </p>
        </v-card-text>
        <v-btn @click="showReminderModal = false" color="primary" large style="font-size: 1.3em">OK</v-btn>
      </v-card>
    </v-dialog>

    <!-- <v-carousel-item>
      <Welcome />
    </v-carousel-item> -->

    <v-carousel-item>
      <VirgilLangford />
    </v-carousel-item> 

    <v-carousel-item>
      <OconeeConnector />
    </v-carousel-item> 

    <!-- <v-carousel-item>
      <Detour />
    </v-carousel-item> -->

    <v-carousel-item>
      <Environmental />
    </v-carousel-item>

    <v-carousel-item>
      <RightOfWay />
    </v-carousel-item>

    <!-- <v-carousel-item>
      <Comment />
    </v-carousel-item> -->

  </v-carousel>
</template>

<script>
// import Welcome from "@/components/Welcome.vue";
import VirgilLangford from "@/components/VirgilLangford.vue";
import OconeeConnector from "@/components/OconeeConnector.vue";
// import Detour from "@/components/Detour.vue";
import Environmental from "@/components/Environmental.vue";
import RightOfWay from "@/components/RightOfWay.vue";
// import Comment from "@/components/Comment.vue";
import HelpText from "@/components/HelpText.vue";

export default {
  name: "Workshop",
  components: {
    // Welcome,
    VirgilLangford,
    OconeeConnector,
    // Detour,
    Environmental,
    RightOfWay,
    // Comment,
    HelpText,
  },
  props: {
    workShopSlide: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    slideTitle: {
      type: String,
      default: ""
    },
    helpText: {
      type: String,
      default: ""
    },
    reminderText: {
      type: String,
      default: ""
    },
    aboutText: {
      type: String,
      default: ""
    },
    showHelpText: {
      type: Boolean,
      default: true
    },
    showAboutText: {
      type: Boolean,
      default: false
    },
    showReminderModal: {
      type: Boolean,
      default: false
    },
    slideVisited: {
      type: Array,
      default: () => {
        return [];
      }
    },
    getSlideHelpText: {
      type: Function
    },
    getSlideAboutText: {
      type: Function
    },
    toggleHelpText: {
      type: Function
    },
    toggleAboutText: {
      type: Function
    },
    toggleReminderModal: {
      type: Function
    }
  },
  data() {
    return {
      updatedSlideValue: 0,
    };
  },
  computed: {
    workShopSlideComputed: {
      get: function() {
        return this.workShopSlide;
      },
      set: function(value) {
        this.updatedSlideValue = value;
      }
    },
    carouselStyle() {
      return {
        "--hidePrev": this.workShopSlideComputed === 0 ? "none" : "block",
        // "--hideNext": this.workShopSlideComputed === 5 ? "none" : "block",
        "--hideNext": this.workShopSlideComputed === 3 ? "none" : "block",
        "--arrowSize": `scale(${this.$vuetify.breakpoint.width / 500})`,
        "--arrowMargin": `0 ${this.$vuetify.breakpoint.width / 25}px`
      };
    }
  },
  methods: {
    updateSlide() {
      // if (this.updatedSlideValue -1 === 0) {
      //   this.showReminderModal = true
      // }
      // if (this.slideTitle === "Executive Summary") {
      //   this.showReminderModal = true
      // }
      this.$emit("update-slide", this.updatedSlideValue);
    },
  }
};
</script>

<style>
.v-carousel__item {
  height: 100% !important;
  overflow: hidden;
  /* background: url("../../public/static/gdot-background.png") !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: bottom !important; */
}
.v-window__prev {
  position: fixed !important;
  transform: var(--arrowSize);
  margin: var(--arrowMargin) !important;
  display: var(--hidePrev);
}
.v-window__next {
  position: fixed !important;
  transform: var(--arrowSize);
  margin: var(--arrowMargin) !important;
  display: var(--hideNext);
}
/* .v-list--dense .v-list-item {
  min-height: 75px !important;
} */
.v-list--dense .v-list-item .v-list-item__title {
  /* font-size: 1.5rem !important; */
  /* font-weight: 1000 !important; */
  line-height: 2.25rem !important;
}
/* .v-list-item-group .v-list-item--active .v-list-item__title {
  font-size: 2rem !important;
} */

.help {
  font-size: 1.5em;
  line-height: 1.3;
}

.v-icon-notranslate-mdi-mdi-chevron-right-theme--light:hover {
color: pink
}

@media only screen and (max-width: 812px) {
  .help {
    font-size: 1em;
  }
}
</style>
